/* eslint-disable func-names */
import $ from "jquery";
import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation, EffectFade, Scrollbar } from 'swiper/modules';
import 'swiper/css/bundle';
import 'swiper/css/effect-fade';
import CountAction from "@/js/plugins/CountAction";
import { countUpAction } from "@/js/helpers";
import { parentChildCheckbox } from "@/js/components/others/_search-list";

const banner = () => {
    const element = document.querySelector('.js-banner-swiper');

    if (!element) return;

    const wrapper = element.querySelector('.swiper-wrapper');
    const originalSlides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
    const originalCount = originalSlides.length;

    if (originalCount === 0) return;

    // 768px以上の場合のみクローン追加
    if (window.innerWidth >= 768) {
        // スライドを十分に複製（最小12枚を目指す）
        const minSlides = 12;
        if (originalCount < minSlides) {
            const fragment = document.createDocumentFragment();
            const repeatCount = Math.ceil(minSlides / originalCount);

            for (let i = 1; i < repeatCount; i++) {
                originalSlides.forEach(slide => {
                    fragment.appendChild(slide.cloneNode(true));
                });
            }
            wrapper.appendChild(fragment);
        }
    }

    const swiper = new Swiper('.js-banner-swiper', {
        modules: [Navigation, Autoplay],
        loop: true,
        loopAdditionalSlides: window.innerWidth >= 768
            ? Math.ceil(originalCount / 2) + 2
            : 0,
        speed: 1000,
        slidesPerView: 2.7,
        spaceBetween: 30,
        centeredSlides: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
    });
};

const contract = () => {
    const swiper = new Swiper(".js-contract-swiper,.js-event-swiper", {
        modules: [Navigation, Scrollbar],
        speed: 1000,
        slidesPerView: 1.5,
        spaceBetween: 20,
        centeredSlides: true,
        freeMode: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        scrollbar: {
            el: '.swiper-scrollbar',
        },
        breakpoints: {
            768: {
                freeMode: false,
                centeredSlides: false,
                slidesPerView: 4,
            }
        }
    });
}
const column = () => {
    const isSp = window.matchMedia('(max-width: 767px)').matches;

    // SP時のみSwiper初期化
    if (isSp) {
        const swiper = new Swiper(".js-column-swiper", {
            modules: [Scrollbar],
            speed: 1000,
            slidesPerView: 2.5,
            spaceBetween: 20,
            // centeredSlides: true,
            freeMode: true,
            scrollbar: {
                el: '.swiper-scrollbar',
            },
        });
    }
}

const area = () => {
    const isSp = window.matchMedia('(max-width: 767px)').matches;

    if (isSp) {
        // SP: 横スクロール
        const swiper1 = new Swiper(".js-area-swiper01", {
            modules: [Autoplay],
            loop: true,
            slidesPerView: 2,
            spaceBetween: 20,
            speed: 10000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            freeMode: true,
            freeModeMomentum: false,
            allowTouchMove: true,
        });

        const swiper2 = new Swiper(".js-area-swiper02", {
            modules: [Autoplay],
            loop: true,
            slidesPerView: 2,
            spaceBetween: 20,
            speed: 10000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                reverseDirection: true,
            },
            freeMode: true,
            freeModeMomentum: false,
            allowTouchMove: true,
        });
    } else {
        // PC: 縦スクロール
        const swiper1 = new Swiper(".js-area-swiper01", {
            modules: [Autoplay],
            direction: 'vertical',
            loop: true,
            slidesPerView: 3,
            speed: 6000,
            allowTouchMove: false,
            spaceBetween: 20,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
        });

        const swiper2 = new Swiper(".js-area-swiper02", {
            modules: [Autoplay],
            direction: 'vertical',
            loop: true,
            slidesPerView: 3,
            speed: 6000,
            allowTouchMove: false,
            spaceBetween: 15,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                reverseDirection: true,
            },
        });
    }

    // 滑らかなスクロール用
    const wrappers = document.querySelectorAll('.js-area-swiper01 .swiper-wrapper, .js-area-swiper02 .swiper-wrapper');
    wrappers.forEach(wrapper => {
        wrapper.style.transitionTimingFunction = 'linear';
    });
};

const renderTypeList = () => {
    const selectObj = document.querySelector('.pg-search__head select[name="type"]');
    const typeCategory = document.querySelector('.pg-search__select').dataset.active;
    console.log(typeCategory);
    const typeList = document.querySelector(`.pg-search__select span[data-type-category="${typeCategory}"]`).dataset.typeList.split(',');
    typeList.forEach((type) => {
        selectObj.querySelector(`option[value="${type}"]`).style.display = 'block';
    });
    selectObj.querySelectorAll('option').forEach((obj) => {
        if (!typeList.includes(obj.value)) {
            obj.style.display = 'none';
        }
    });
    selectObj.value = typeList[0];
}

const renderAreaList = () => {
    const typeSelector = document.querySelector('.pg-search__head select[name="type"]');
    const type = document.querySelector('.pg-search__head select[name="type"]').value;
    document.querySelectorAll('.pg-search__area').forEach((obj) => {
        if (obj.dataset.type === type) {
            obj.dataset.active = '';
        } else {
            delete obj.dataset.active;
        }
    });
    document.querySelectorAll('.pg-search__content input[type="checkbox"]').forEach((obj) => {
        obj.checked = false;
    });
    countChangeAction(0);
}

const setSearchCountAction = (obj) => {
    const countAction = new CountAction(obj);
    countAction.on('countChange', (e) => {
        countChangeAction(e.count);
    });
}

const countChangeAction = (count) => {
    const target = document.querySelector('[data-pickup-count]');
    countUpAction(target, count);
    if (count == 0) {
        target.parentElement.dataset.empty = '';
        document.querySelector('.pg-search-links button').setAttribute('disabled', '');
    } else {
        delete target.parentElement.dataset.empty;
        document.querySelector('.pg-search-links button').removeAttribute('disabled');
    }
}

const searchSwitch = () => {
    document.querySelector('.pg-search__head select[name="type"]').addEventListener('change', (e) => {
        renderAreaList();
    });

    document.querySelectorAll('.pg-search__select span').forEach((obj) => {
        obj.addEventListener('click', (e) => {
            const typeCategory = e.currentTarget.dataset.typeCategory;
            document.querySelector('.pg-search__select').dataset.active = typeCategory;
            renderTypeList();
            renderAreaList();
        });
    });
    renderTypeList();
    renderAreaList();
    document.querySelectorAll('.pg-search form:has([data-pickup-search])').forEach((obj) => {
        setSearchCountAction(obj);
    });
}

const main = () => {
    if (document.querySelector('#page-home') === null) return;
    banner();
    contract();
    column();
    area();
    document.querySelector('.pg-search__main') && document.querySelector('.pg-search__main').addEventListener('onLoadContents', () => {
        searchSwitch();
        parentChildCheckbox();
    });
}
export default main;
